import { queryKeys as controlTestingQueryKeys } from './queries/control-testing/keys.ts';
import { risksQueryKeys } from './queries/risks/keys.ts';
import { rcmQueryKeys } from './queries/rcm/keys.ts';

export const queryKeys = {
  ...controlTestingQueryKeys,
  risks: risksQueryKeys,
  rcm: rcmQueryKeys,
} as const;

export { SOX_CYCLES_QUERY_KEY, cycleProcessesQueryKey, processesQueryKey, soxQueryKeys } from './queries/sox/keys';